import { lazy } from 'react'

// Check localStorage availability once and store the result
const localStorageAvailable = (() => {
  try {
      const testKey = "__test__"
      window.localStorage.setItem(testKey, "test")
      window.localStorage.removeItem(testKey)
      return true
  } catch (error) {
      return false
  }
})()

// Global flag to track if the alert has been shown
let alertShown = false;

// Show alert if localStorage is unavailable and alert hasn't been shown
if (!localStorageAvailable && !alertShown) {
  alertShown = true
  alert("localStorage is disabled or unavailable. Please enable it in your browser settings to ensure the application functions correctly.")
}

export const lazyWithRetry = (componentImport) => {
  return lazy(async () => {

    // --- SAFE localStorage read ---
    let pageHasAlreadyBeenForceRefreshed = false
    try {
      const storedValue = localStorageAvailable
        ? window.localStorage.getItem('page-has-been-force-refreshed')
        : 'false'

      pageHasAlreadyBeenForceRefreshed = JSON.parse(storedValue || 'false')
    } catch (error) {
      pageHasAlreadyBeenForceRefreshed = false
    }

    try {
      const component = await componentImport()

      // --- SAFE write ---
      try {
        if (localStorageAvailable) {
          window.localStorage.setItem('page-has-been-force-refreshed', 'false')
        }
      } catch (error) {
        // Ignore for Googlebot or blocked localStorage
      }

      return component
    } catch (error) {
      if (!pageHasAlreadyBeenForceRefreshed) {
        // Assuming that the user is not on the latest version of the application.
        // Let's refresh the page immediately.

        // --- SAFE write ---
        try {
          if (localStorageAvailable) {
            window.localStorage.setItem('page-has-been-force-refreshed', 'true')
          }
        } catch (error) {
          // Ignore for Googlebot or blocked localStorage
        }

        return window.location.reload()
      }

      // The page has already been reloaded
      // Assuming that user is already using the latest version of the application.
      // Let's let the application crash and raise the error.
      throw error
    }
  })
}
